import { getGuestLocaleFromStorage } from './resolve-locale';
import { isSupportedLocale } from './constants';

function setOrReplaceQueryParam(searchStr, key, value) {
  var encoded = encodeURIComponent(value);
  var raw = searchStr || '';
  if (raw && raw.charAt(0) !== '?') {
    raw = '?' + raw;
  }
  var re = new RegExp('([?&])' + key + '=[^&]*');
  if (re.test(raw)) {
    return raw.replace(re, '$1' + key + '=' + encoded);
  }
  if (!raw || raw === '?') {
    return '?' + key + '=' + encoded;
  }
  return raw + '&' + key + '=' + encoded;
}

function resolveCurrentAppLocale(localeOverride) {
  if (isSupportedLocale(localeOverride)) {
    return localeOverride;
  }
  try {
    if (typeof window !== 'undefined' && window.vbus && window.vbus.$i18n) {
      var i18nLocale = window.vbus.$i18n.locale;
      if (isSupportedLocale(i18nLocale)) {
        return i18nLocale;
      }
    }
  } catch (e) {
    // ignore
  }
  var guest = getGuestLocaleFromStorage();
  return isSupportedLocale(guest) ? guest : null;
}

/** 跨应用跳转时在 URL 上附带当前语言 */
export function appendAppLocaleQuery(searchStr, localeOverride) {
  var locale = resolveCurrentAppLocale(localeOverride);
  if (!locale) {
    return searchStr || '';
  }
  if (arguments.length < 2 && searchStr && searchStr.indexOf('appLocale=') !== -1) {
    return searchStr;
  }
  return setOrReplaceQueryParam(searchStr || '', 'appLocale', locale);
}

export function normalizeVccOnlineRecharge(vccOnlineRecharge) {
  return (
    vccOnlineRecharge === true ||
    vccOnlineRecharge === 1 ||
    vccOnlineRecharge === '1' ||
    vccOnlineRecharge === 'true'
  );
}

export function appendVccOnlineRechargeQuery(searchStr, vccOnlineRecharge) {
  if (vccOnlineRecharge === undefined || vccOnlineRecharge === null) {
    return searchStr || '';
  }
  var value = normalizeVccOnlineRecharge(vccOnlineRecharge) ? '1' : '0';
  return setOrReplaceQueryParam(searchStr || '', 'vccOnlineRecharge', value);
}

/** 闪付授权链接查询参数：语言 + 在线充值权限 */
export function appendShanfuAuthQuery(searchStr, options) {
  options = options || {};
  var result = appendAppLocaleQuery(searchStr || '', options.locale);
  var hasPerm =
    options.vccOnlineRecharge !== undefined && options.vccOnlineRecharge !== null
      ? options.vccOnlineRecharge
      : false;
  return appendVccOnlineRechargeQuery(result, hasPerm);
}
